module.exports = __webpack_public_path__ + "static/img/banner-3.b336493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-3.png
// module id = Nz4X
// module chunks = 1